import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { Data } from '../../helpers';
import { ErrorHandlerService } from '../../services';
var SubscribersComponent = /** @class */ (function () {
    function SubscribersComponent(data, dashboardService, errorHandlerService, router, route) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.route = route;
        this.showRequestReco = false;
        this.reqforrcmd = false;
        this.ratethis = false;
        this.query = '';
        this.sendMsg = false;
        this.msgData = {};
        this.allTopicsSubs = [];
        this.creator = {};
        this.startTime = {};
        this.endTime = {};
        this.users = [];
        this.reqRcmd = { requestTo: {}, requestFrom: {} };
        this.rating = { responseTo: {}, responseFrom: {}, rating: {} };
        this.invitereq = { requestTo: {}, requestFrom: {} };
        this.viewProfile = {};
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.removeSubs = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.topicTO = {};
    }
    SubscribersComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    SubscribersComponent.prototype.ngOnInit = function () {
        this.initFn();
    };
    SubscribersComponent.prototype.initFn = function () {
        var _this = this;
        this.showSpinner = true;
        this.dashboardService.userSummary1().subscribe(function (data) {
            _this.userId = data.userDetailsId;
            _this.invitereq.requestFrom.userDetailsId = data.userDetailsId;
            _this.reqRcmd.requestFrom.userDetailsId = data.userDetailsId;
            _this.rating.responseFrom.userDetailsId = data.userDetailsId;
        }, function (error) {
            _this.handleError(error);
        });
        this.route.queryParams.subscribe(function (params) {
            _this.query = params['topic'] || 0;
            if (_this.query != '0') {
                _this.dashboardService.getTopicSubs(_this.query).subscribe(function (data) {
                    console.log(data);
                    _this.allTopicsSubs = data.topicTO.topicSubscribers;
                    _this.topicTO = data.topicTO;
                    if (_this.userId == data.topicTO.userDetailsSummaryTO.userDetailsId) {
                        _this.removeSubs = true;
                    }
                    _this.showSpinner = false;
                    //  this.creator = data.creator;
                    //  this.users = data.users;
                }, function (error) {
                    _this.handleError(error);
                });
            }
        });
    };
    SubscribersComponent.prototype.remSubs = function (subId) {
        var _this = this;
        this.dashboardService.removeSubscriber(this.query, subId).subscribe(function (data) {
            console.log(data);
            _this.initFn();
            // this.allTopicsSubs = data.topicTO.topicSubscribers;
            // if(this.userId == data.topicTO.userDetailsSummaryTO.userDetailsId){
            //     this.removeSubs = true;
            // }
        }, function (error) {
            _this.handleError(error);
        });
    };
    SubscribersComponent.prototype.rcmdReq = function () {
        var _this = this;
        this.reqforrcmd = true;
        this.reqRcmd.userRequestType = 'RECOMMENDATION_REQUEST';
        console.log(this.reqRcmd);
        this.dashboardService.rcmdRequest(this.reqRcmd).subscribe(function (data) {
            _this.reqforrcmd = false;
            _this.reqRcmd.userRequestText = '';
            _this.showRequestReco = false;
            _this.createInfoAlert("Recommendation Request sent successfully!!");
        }, function (error) {
            _this.showRequestReco = false;
            _this.reqforrcmd = false;
            _this.handleError(error);
        });
    };
    SubscribersComponent.prototype.ratingUser = function (subscriber) {
        var _this = this;
        if (this.rating.rating.ratingText == null || this.rating.rating.ratingText == '' || this.rating.rating.ratingText == undefined) {
            this.createInfoAlert("Please select a rating from Best/Fair/Good.");
            return;
        }
        this.showSpinner = true;
        this.rating.userResponseType = 'RATING_RESPONSE';
        console.log(this.rating);
        this.dashboardService.rating(this.rating).subscribe(function (data) {
            _this.rating.rating.ratingText = "";
            subscriber.userDetailsSummaryTO.ratingAction = 'RATING_ALREADY_SENT';
            _this.showSpinner = false;
            _this.createInfoAlert("Rating submitted successfully!!");
        }, function (error) {
            _this.handleError(error);
        });
    };
    SubscribersComponent.prototype.sendInvite = function (id) {
        var _this = this;
        this.invitereq.requestTo.userDetailsId = id;
        this.invitereq.userRequestText = "Invitation Request sent by User Id " + this.invitereq.requestFrom.userDetailsId + " to User Id " + id + ". Sent by REST Service.";
        this.invitereq.userRequestType = 'INVITATION_REQUEST';
        console.log(this.invitereq);
        this.dashboardService.sendInvitationReq(this.invitereq).subscribe(function (data) {
            _this.createInfoAlert('Invitation Request sent successfully!!');
            _this.initFn();
        }, function (error) {
            _this.handleError(error);
        });
    };
    SubscribersComponent.prototype.sendMessg = function (data) {
        this.viewProfile = data;
        this.sendMsg = true;
    };
    SubscribersComponent.prototype.sendMessage = function () {
        var _this = this;
        this.msgData.usersInTo = [this.viewProfile.userDetailsId];
        this.dashboardService.inboxSendMsg(this.msgData).subscribe(function (data) {
            _this.sendMsg = false;
            _this.msgData.messageBody = '';
            _this.createInfoAlert('Message sent successfully!!');
        }, function (error) {
            _this.sendMsg = false;
            _this.handleError(error);
        });
    };
    SubscribersComponent.prototype.acceptInvite = function (id) {
        var _this = this;
        this.dashboardService.connAccept(id).subscribe(function (data) {
            _this.createInfoAlert('Invitation Request accepted successfully!!');
            _this.initFn();
        }, function (error) {
            _this.handleError(error);
        });
    };
    SubscribersComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    SubscribersComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.showSpinner = false;
        this.errorHandlerService.throwError(error);
    };
    return SubscribersComponent;
}());
export { SubscribersComponent };
//# sourceMappingURL=subscribers.component.js.map